import { Search, X } from "lucide-react";

// Bară de căutare + filtrul „Post”. Izolat, în stilul ROTY FOOD.
export const MenuControls = ({ query, setQuery, postActive, setPostActive }) => {
  return (
    <div data-testid="menu-controls" className="pt-4">
      <div className="relative">
        <Search
          className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-roty-ash"
          strokeWidth={2.5}
        />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Caută produs..."
          data-testid="menu-search-input"
          aria-label="Caută produs"
          className="h-12 w-full rounded-full border border-roty-line bg-roty-paper pl-11 pr-11 text-base text-roty-ink placeholder:text-roty-ash/70 transition-colors focus:border-roty-red focus:outline-none"
        />
        {query ? (
          <button
            type="button"
            onClick={() => setQuery("")}
            data-testid="menu-search-clear"
            aria-label="Șterge căutarea"
            className="absolute right-3 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-roty-ash transition-colors hover:bg-roty-line/60 hover:text-roty-red"
          >
            <X className="h-4 w-4" strokeWidth={2.5} />
          </button>
        ) : null}
      </div>
      <div className="mt-3">
        <button
          type="button"
          data-testid="menu-filter-post"
          aria-pressed={postActive}
          onClick={() => setPostActive(!postActive)}
          className={`shrink-0 whitespace-nowrap rounded-full border px-4 py-2 text-[12px] font-extrabold uppercase tracking-wide transition-colors ${
            postActive
              ? "border-roty-red bg-roty-red text-white"
              : "border-roty-line bg-roty-paper text-roty-ink/80 hover:border-roty-gold hover:text-roty-red"
          }`}
        >
          DE POST
        </button>      </div>
    </div>
  );
};

export default MenuControls;
